import Button from 'components/Button/Button';
import { FilterPopover } from 'components/FilterComponents/FilterPopover/FilterPopover';
import { FilterOption, FilterType } from 'components/FilterComponents/FilterPopover/types';

interface FiltersProps {
  externalIdFilter: string;
  nameFilter: string;
  typeFilter: string[];
  typeFilterOptions: FilterOption[];
  onExternalIdChange: (value: string) => void;
  onNameChange: (value: string) => void;
  onTypeChange: (value: string) => void;
  onClearFilters: () => void;
}

export const Filters = ({
  externalIdFilter,
  nameFilter,
  typeFilter,
  typeFilterOptions,
  onExternalIdChange,
  onNameChange,
  onTypeChange,
  onClearFilters
}: FiltersProps) => {
  const hasAnyFilter = !!externalIdFilter || !!nameFilter || typeFilter.length > 0;

  const filterConfigs = [
    {
      key: 'externalId',
      label: 'Offer Design External ID',
      filterType: FilterType.FREE_SEARCH,
      onChange: onExternalIdChange,
      getSelectedItems: () => (externalIdFilter ? [externalIdFilter] : [])
    },
    {
      key: 'name',
      label: 'Offer Design Name',
      filterType: FilterType.FREE_SEARCH,
      onChange: onNameChange,
      getSelectedItems: () => (nameFilter ? [nameFilter] : [])
    },
    {
      key: 'type',
      label: 'Offer Design Type',
      filterType: FilterType.CHECKLIST,
      options: typeFilterOptions,
      onChange: onTypeChange,
      getSelectedItems: () => typeFilter,
      popoverHeight: 'auto'
    }
  ];

  return (
    <div className="flex flex-row flex-wrap items-center gap-2 px-7 mb-5">
      {filterConfigs.map(({ key, getSelectedItems, ...filterProps }) => (
        <FilterPopover
          key={key}
          selectedItems={getSelectedItems()}
          {...filterProps}
        />
      ))}
      {hasAnyFilter && (
        <Button
          variant="text"
          onClick={onClearFilters}
          className="text-base-primary border-none hover:bg-none text-indigo-600 text-xs"
        >
          Clear all
        </Button>
      )}
    </div>
  );
};
